import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../../modules/resources";
import Tabs from "Components/tabs/Tabs";
import Retention from "./settings/Retention";
import Details from "./settings/Details";
import QboxmailApi from "../../../qboxmailApi.js";
import withFormState from "Components/withFormState";
import { alertSuccess } from "Utils/alerts";
import PropTypes from "prop-types";
import { formatServerErrors } from "Utils/serverFormats";
import t from "Utils/translation";

const formInitialState = {
  retention: 3,
};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class ArchiveEmailAccountSettings extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    const {
      refreshEmailAccount,
      setFormLoading,
      unsetFormLoading,
      setFormErrors,
      formData,
      match: {
        params: { domainCode, emailCode },
      },
    } = this.props;

    e.preventDefault();
    setFormLoading();
    const api = new QboxmailApi({ useCookie: true });
    api
      .editArchiveEmailAccount(emailCode, domainCode, formData)
      .then(() => {
        unsetFormLoading();
        refreshEmailAccount(emailCode, domainCode);
        this.props.setInitialValues({
          default_retention: formData.default_retention,
          default_archive: formData.default_archive,
          retention: formData.retention,
        });
        alertSuccess(t("alert.emailUpdatedSuccess"));
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          setFormErrors(errors);
          unsetFormLoading();
        });
      });
  }

  render() {
    return (
      <Tabs
        {...this.props}
        tabs={{
          [t("tab.details")]: <Details {...this.props} />,
          [t("tab.settings")]: <Retention submitForm={this.submitForm} {...this.props} />,
        }}
      />
    );
  }
}

ArchiveEmailAccountSettings.contextTypes = ContextTypes;

//eslint-disable-next-line no-unused-vars
const mapStateToProps = (state) => ({
  // domain: resActions.getData('domain.data.0', state),
  // isDomainLoading: resActions.isResourceLoading('domain', state),
  // outboundLimits: resActions.getData('outboundLimits.data', state)
});

const mapDispatchToProps = (dispatch) => ({
  refreshEmailAccount: (code, codeDomain) =>
    dispatch(resActions.callApi("refreshEmailAccount", "email_account", codeDomain, code)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormState(ArchiveEmailAccountSettings, formInitialState));
